import { useCallback, useEffect, useState } from 'react';
import ApiDatabase from 'server';
import useInvoiceReminderChanged from './useInvoiceReminderChanged';

/**
 * The summary of the reminders (JBWEB-1283): `{ toDo, lateAmount, litigation:
 * { count, amount } }`, the counter of the "Rappels / Relances" tab and the
 * cards of its screen. Read only when `enabled` (the admin has
 * `accessInvoice`: the route refuses the others), and again on `reload`. A
 * failed read keeps the last summary read.
 *
 * Held by the page, it also reads again when a reminder is sent by hand: the
 * modal may be opened from the invoice detail on another tab than
 * « Rappels / Relances », where nothing else would refresh the counter.
 */
const useRemindersSummary = (enabled) => {
  const [state, setState] = useState({ summary: null, failed: false });

  const reload = useCallback(() => {
    if (!enabled) return;
    ApiDatabase.getInvoiceRemindersSummary(
      {},
      (data) => setState({ summary: data ?? null, failed: false }),
      (error) => {
        if (error?.name === 'CanceledError') return;
        setState((current) => ({ summary: current.summary, failed: true }));
      },
    );
  }, [enabled]);

  useEffect(() => {
    reload();
  }, [reload]);

  useInvoiceReminderChanged(reload);

  return { ...state, reload };
};

export default useRemindersSummary;
